import { Component, Input } from "@angular/core"
import { ScriptService } from "../../../services/script-service.service"

declare var window: any

@Component({
    selector: "app-pinterest-share",
    templateUrl: "./pinterest-share.component.html",
    styleUrls: ["./pinterest-share.component.scss"],
    standalone: false,
})
export class PinterestShareComponent {
    @Input() simpleIcon: boolean = false

    constructor(private scriptService: ScriptService) {
        scriptService.load("pinterest").then()
    }
    public share() {
        if (window.PinUtils) {
            window.PinUtils.pinAny()
        }
    }
}
